import {
    Close
} from '@mui/icons-material';
import {
    Box,
    Container,
    IconButton,
    Modal,
    Stack, Typography
} from "@mui/material";
import { useEffect, useState } from "react";
// import constantAC from '../../assets/carbonEmissionEffects/constantAC.PNG';
// import constantAC_data from '../../assets/carbonEmissionEffects/constantAC_data.png';
import { Icon } from '@iconify/react';
import expensiveFood from '../../assets/carbonEmissionEffects/expensiveFood.PNG';
import expensiveFood_data from '../../assets/carbonEmissionEffects/expensiveFood_data.jpg';
import extremelyHotDays from '../../assets/carbonEmissionEffects/extremelyHotDays.PNG';
import extremelyHotDays_data from '../../assets/carbonEmissionEffects/extremelyHotDays_data.png';
import migrateOutOfSG from '../../assets/carbonEmissionEffects/migrateOutOfSG.PNG';
import migrateOutOfSG_data from '../../assets/carbonEmissionEffects/migrateOutOfSG_data.jpg';
import risingSeaLevels from '../../assets/carbonEmissionEffects/risingSeaLevels.PNG';
import risingSeaLevels_data from '../../assets/carbonEmissionEffects/risingSeaLevels_data.png';

const CE_effects = [
    {
        title: 'my home will be surrounded by sea by the year 2100!',
        image: risingSeaLevels,
        dataImage: risingSeaLevels_data,
        dataDescription: 'Under the medium emission scenario (SSP2-4.5) and high emission scenario (SSP5-8.5), the average sea level could rise by 1.9 to 2.6 feet by the year 2100.',
    },
    {
        title: 'I will not be able to step out at all in the afternoon for 200 days in a year!',
        image: extremelyHotDays,
        dataImage: extremelyHotDays_data,
        dataDescription: 'High heat stress days (Wet bulb temperature* more than 33 degrees Celsius which is quite hazardous, even fatal, to humans) will be 142 and 270 by 2100 under the medium emission scenario (SSP2-4.5) and high emission scenario (SSP5-8.5). At present, it is 8.',
        dataFooter: '* A wet bulb temperature measures both heat and humidity to indicate how well the body can cool itself through sweating. At 33°C or higher, even with shade and proper hydration, a person cannot survive more than 5-7 hours as the body\'s cooling mechanisms fail, leading to fatal heat stress.'
    },
    // {
    //     title: 'I will need constant AC everywhere!',
    //     image: constantAC,
    //     dataImage: constantAC_data,
    //     dataDescription: 'The average number of warm nights (More than 26.3 degree Celsius) will be 362 and 365 and average number of warm days (more than 34 degrees Celsius) will be 266 and 340 by 2100 under the medium emission scenario (SSP2-4.5) and high emission scenario (SSP5-8.5).'
    // },
    {
        title: 'we will have to migrate out of Singapore!',
        image: migrateOutOfSG,
        dataImage: migrateOutOfSG_data,
        dataDescription: 'Given the potential for rising sea levels, more extreme heat, and more frequent dangerously hot days and nights, Singapore could become unliveable by 2100. This might force people to migrate to cooler regions.'
    },
    {
        title: 'my food will be much more expensive and less nutritious!',
        image: expensiveFood,
        dataImage: expensiveFood_data,
        dataDescription: 'Research shows that the higher CO2 concentrations can lower protein content and essential minerals in crops like wheat and rice. Also, overall crop yields will decrease with increasing temperature, there will be more pests and disease proliferation. As Singapore imports 90% of its food, it is a given that the food prices will increase sharply.'
    },
]

function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default function CarbonEmissionEffectCard() {
    const [selectedVisual, setVisual] = useState({});

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        let randomIndex = randomNumberInRange(0,CE_effects.length-1);
        setVisual( CE_effects[randomIndex] );
    }, []);
    return (
        <>{ Object.keys(selectedVisual)?.length > 0 &&
            <>
            {/* Minimized Card */}
            <Box className="centered-y" sx={{ textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>
                    So what does this mean?
                </Typography>
                <Typography variant="body2" gutterBottom>
                    If we continue to emit this level of carbon, then... {selectedVisual?.title}
                </Typography>
                <Box className="centered-x" sx={{ my: 1, cursor: 'pointer', '&:hover': { color: 'var(--pri-purple)' } }} >
                    <Icon icon="material-symbols:info-outline" fontSize={22} /> 
                    <Typography variant="body2" sx={{ fontSize: 12, lineHeight: 1.8 }} onClick={()=>handleOpen()}>&ensp;Learn More</Typography>
                </Box>
                <Box alt={selectedVisual?.title} sx={{ width: '70%', margin: 'auto',  aspectRatio: 1, background: `white url(${selectedVisual?.image}) no-repeat center`, backgroundSize: 'cover' }} />
                <Typography variant="h5" sx={{ color: 'var(--red)' }}>
                    We must act now!
                </Typography>
            </Box>

            {/* Fullscreen Card */}
            <Modal
            open={open}
            onClose={handleClose}
            >
            <Container maxWidth={'xs'} className='modal-container' sx={{ padding: 3 }}>
            <Box sx={{ flex: 'auto' }} className='spread-y'>
                <Stack spacing={2}>
                    {/* <Box sx={{ minHeight: '100px', width: '100%', borderRadius: '16px 16px 0 0', background: `var(--light-green) url(${selectedVisual?.dataImage}) no-repeat center`, backgroundSize: 'contain' }} /> */}
                    <img src={selectedVisual?.dataImage} style={{ width: '100%', borderRadius: '16px 16px 0 0' }} alt="coin icon" />

                    <Box className='spread-x' sx={{ alignItems: 'start' }}>
                        <Typography variant="h6">
                            { selectedVisual?.title?.charAt(0).toUpperCase() + selectedVisual?.title?.slice(1,-1) }
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Typography variant="body2">
                        { selectedVisual?.dataDescription }
                    </Typography>
                    <Typography variant="caption">
                        { selectedVisual?.dataFooter }
                    </Typography>
                </Stack>
            </Box>
            </Container>
            </Modal>
            </>
        } </>
    )
}